import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import styled from 'styled-components';
import { Modal, Skeleton, Space, Tooltip } from 'antd';
import { useEffect, useRef } from 'react';
import { Form } from '@module/form';
import { CreateAssignmentForm } from './create-assignment-form.component';
import { PrimaryButton, SecondaryButton, useModalEnter } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledModal = styled(Modal).withConfig({
  displayName: "create-assignment-modalcomponent__StyledModal",
  componentId: "sc-g6lmuy-0"
})(["width:60% !important;@media (max-width:768px){width:calc(100% - 24px) !important;max-width:calc(100% - 24px);}.ant-modal-content{padding:16px 20px;border-radius:12px;overflow:hidden;display:flex;flex-direction:column;height:95vh;@media (max-width:768px){padding:16px 12px;}}.ant-modal-header{border-bottom:none;flex-shrink:0;padding:0 0 12px;margin-bottom:0;}.ant-modal-body{overflow-y:hidden;flex:1;min-height:0;display:flex;flex-direction:column;padding:0 4px;@media (max-width:768px){overflow-y:auto;}}.ant-modal-footer{flex-shrink:0;padding:12px 0 0;margin-top:0;}"]);
var StyledFormTitle = styled.span.withConfig({
  displayName: "create-assignment-modalcomponent__StyledFormTitle",
  componentId: "sc-g6lmuy-1"
})(["font-weight:700;font-size:20px;line-height:28px;"]);
export var CreateAssignmentModal = function CreateAssignmentModal(props) {
  var form = props.form,
      isModalVisible = props.isModalVisible,
      onCancelModal = props.onCancelModal,
      onCreateAssignment = props.onCreateAssignment,
      assignmentConfigsResponse = props.assignmentConfigsResponse,
      label = props.label,
      isLoadingCreateAssignment = props.isLoadingCreateAssignment,
      isDisableCreateAssignment = props.isDisableCreateAssignment,
      onFormValuesChange = props.onFormValuesChange,
      formErrorLabel = props.formErrorLabel,
      assignmentType = props.assignmentType,
      securityOptions = props.securityOptions,
      isLoadingGetSecurityOptions = props.isLoadingGetSecurityOptions,
      editorLabels = props.editorLabels,
      defaultAssignmentTitle = props.defaultAssignmentTitle,
      formTotalScore = props.formTotalScore,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'create' : _props$mode,
      assignmentTypeDisabledReason = props.assignmentTypeDisabledReason,
      submitDisabledReason = props.submitDisabledReason,
      cancelDisabledReason = props.cancelDisabledReason,
      _props$isLoadingAssig = props.isLoadingAssignment,
      isLoadingAssignment = _props$isLoadingAssig === void 0 ? false : _props$isLoadingAssig,
      beforeFormContent = props.beforeFormContent,
      passwordContent = props.passwordContent,
      practiceScoreContent = props.practiceScoreContent;
  var submitLock = useRef(false);

  var submit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!isModalVisible || isDisableCreateAssignment || isLoadingCreateAssignment || isLoadingAssignment || submitLock.current)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              submitLock.current = true;
              _context.prev = 3;
              _context.next = 6;
              return onCreateAssignment();

            case 6:
              _context.prev = 6;
              submitLock.current = false;
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3,, 6, 9]]);
    }));

    return function submit() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleEnter = useModalEnter(submit, isDisableCreateAssignment || isLoadingCreateAssignment || isLoadingAssignment);
  var prevDefaultTitleRef = useRef(undefined);
  useEffect(function () {
    if (mode === 'edit') return;

    if (!isModalVisible) {
      prevDefaultTitleRef.current = undefined;
      return;
    }

    var title = Form.getDefaultAssignmentTitle(defaultAssignmentTitle);

    if (!title) {
      return;
    }

    if (prevDefaultTitleRef.current !== defaultAssignmentTitle) {
      form.setFieldValue('title', title);
      onFormValuesChange();
      prevDefaultTitleRef.current = defaultAssignmentTitle;
    }
  }, [defaultAssignmentTitle, form, isModalVisible, onFormValuesChange, mode]);

  var renderAssignmentFormContent = function renderAssignmentFormContent() {
    if (isLoadingAssignment || !assignmentConfigsResponse) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true,
        paragraph: {
          rows: 8
        }
      });
    }

    return /*#__PURE__*/_jsx(CreateAssignmentForm, {
      mode: mode,
      assignmentTypeDisabledReason: assignmentTypeDisabledReason,
      passwordContent: passwordContent,
      practiceScoreContent: practiceScoreContent,
      participationFields: props.participationFields,
      form: form,
      assignmentConfigsResponse: assignmentConfigsResponse,
      onFormValuesChange: onFormValuesChange,
      label: label,
      errorLabel: formErrorLabel,
      assignmentType: assignmentType,
      securityOptions: securityOptions,
      isLoadingGetSecurityOptions: isLoadingGetSecurityOptions,
      editorLabels: editorLabels,
      isModalVisible: isModalVisible,
      formTotalScore: formTotalScore
    });
  };

  return /*#__PURE__*/_jsxs(StyledModal, {
    centered: true,
    open: isModalVisible,
    wrapProps: {
      onKeyDownCapture: handleEnter
    },
    onCancel: onCancelModal,
    destroyOnClose: true,
    maskClosable: mode === 'create',
    title: /*#__PURE__*/_jsx(StyledFormTitle, {
      children: label.createAssignment
    }),
    footer: /*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      size: "small",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        trigger: ['hover', 'focus'],
        title: isLoadingCreateAssignment ? cancelDisabledReason : undefined,
        children: /*#__PURE__*/_jsx("span", {
          tabIndex: isLoadingCreateAssignment && cancelDisabledReason ? 0 : undefined,
          children: /*#__PURE__*/_jsx(SecondaryButton, {
            disabled: isLoadingCreateAssignment,
            size: "small",
            onClick: onCancelModal,
            children: label.cancel
          })
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        trigger: ['hover', 'focus'],
        title: isDisableCreateAssignment || isLoadingCreateAssignment ? submitDisabledReason : undefined,
        children: /*#__PURE__*/_jsx("span", {
          tabIndex: (isDisableCreateAssignment || isLoadingCreateAssignment) && submitDisabledReason ? 0 : undefined,
          children: /*#__PURE__*/_jsx(PrimaryButton, {
            size: "middle",
            loading: isLoadingCreateAssignment,
            onClick: submit,
            disabled: isDisableCreateAssignment,
            children: label.assignQuiz
          })
        })
      })]
    }),
    children: [beforeFormContent && /*#__PURE__*/_jsx("div", {
      style: {
        flexShrink: 0
      },
      children: beforeFormContent
    }), renderAssignmentFormContent()]
  });
};